import { render, staticRenderFns } from "./orderIntegral.vue?vue&type=template&id=3b55f762&scoped=true&"
import script from "./orderIntegral.vue?vue&type=script&lang=js&"
export * from "./orderIntegral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55f762",
  null
  
)

export default component.exports